import { firebaseEnv, webBaseUrl } from "../config/env";
export function publicShareUrl(token: string): string {
  const configuredBase = String(webBaseUrl || "").trim();
  let base: URL | null = null;
  try {
    const candidate = new URL(configuredBase || window.location.origin, window.location.origin);
    const localHost = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/i.test(candidate.hostname);
    const nativeScheme = !["http:", "https:"].includes(candidate.protocol);
    if (!localHost && !nativeScheme && !candidate.hostname.endsWith(".invalid")) base = candidate;
  } catch {
    base = null;
  }
  if (!base) {
    const projectId = String(firebaseEnv.projectId || "").trim();
    if (!projectId) throw new Error("SHARE_BASE_URL_MISSING");
    base = new URL(`https://${projectId}.web.app/`);
  }
  base.search = "";
  base.hash = "";
  base.searchParams.set("share", token);
  return base.toString();
}

